const ITEMS = [
  "Commercial Cleaning",
  "Residential Cleaning",
  "Deep Cleaning",
  "Move-In / Move-Out",
  "Janitorial Services",
  "Floor Care",
  "St. Louis, MO",
  "Chesterfield, MO",
  "Free Custom Quotes",
];

export const Marquee = () => (
  <div className="overflow-hidden bg-leaf py-3.5 relative z-10" aria-hidden="true">
    <div className="flex whitespace-nowrap animate-gg-marquee w-max">
      {[0, 1].map((dup) => (
        <div key={dup} className="flex items-center">
          {ITEMS.map((item, i) => (
            <span key={i} className="flex items-center text-forest-deep font-display font-bold text-sm tracking-wide">
              <span className="px-6">{item}</span>
              <svg viewBox="0 0 24 24" className="w-3 h-3 fill-forest-deep/60" aria-hidden="true">
                <path d="M12 2l1.8 6.2L20 10l-6.2 1.8L12 18l-1.8-6.2L4 10l6.2-1.8z" />
              </svg>
            </span>
          ))}
        </div>
      ))}
    </div>
  </div>
);
